
    import { cloudinaryUrl, thumbUrl } from './cloudinary.js'
    import { initIris } from './iris.js'
    initIris()

    let allPhotoItems = []

    Promise.all([
      fetch('/data/categories.json').then(r => r.json()),
      fetch('/data/gallery.json').then(r => r.json())
    ]).then(([categories, items]) => {
      const gridPhoto = document.getElementById('galleryPhoto')
      const tabsEl    = document.getElementById('categoryTabs')
      allPhotoItems   = items.filter(i => i.type === 'photo')

      const allTab = document.createElement('button')
      allTab.className   = 'category-tab active'
      allTab.dataset.cat = 'all'
      allTab.textContent = 'All'
      tabsEl.appendChild(allTab)

      categories.forEach(cat => {
        const btn = document.createElement('button')
        btn.className   = 'category-tab'
        btn.dataset.cat = cat.id
        btn.textContent = cat.label
        tabsEl.appendChild(btn)
      })

      tabsEl.addEventListener('click', e => {
        const btn = e.target.closest('.category-tab')
        if (!btn) return
        tabsEl.querySelectorAll('.category-tab').forEach(b => b.classList.remove('active'))
        btn.classList.add('active')
        renderPhotos(btn.dataset.cat)
      })

      renderPhotos('all')
    }).catch(() => {})

    function renderPhotos(cat) {
      const gridPhoto = document.getElementById('galleryPhoto')
      const filtered = cat === 'all' ? allPhotoItems : allPhotoItems.filter(i => i.category === cat)
      window.__lightboxItems = filtered
      gridPhoto.innerHTML = filtered.length
        ? filtered.map((item, index) => galleryCard(item, index)).join('')
        : '<p class="gallery-empty">Nothing here yet — check back soon.</p>'
    }

    function galleryCard(item, index) {
      return `
        <figure class="gallery-item" onclick="openLightbox(${index})">
          <img src="${thumbUrl(item.url)}" alt="${item.title || ''}" loading="lazy">
          ${item.title ? `<figcaption>${item.title}</figcaption>` : ''}
        </figure>
      `
    }
    window.cloudinaryUrl = cloudinaryUrl

    let __lightboxIndex = 0
    window.openLightbox = function (index) {
      const items = window.__lightboxItems || []
      if (!items.length) return
      __lightboxIndex = index
      showLightboxItem(__lightboxIndex)
      document.getElementById('lightbox').classList.add('active')
    }
    function showLightboxItem(index) {
      const items = window.__lightboxItems || []
      if (!items.length) return
      __lightboxIndex = (index + items.length) % items.length
      const item = items[__lightboxIndex]
      document.getElementById('lightboxImg').src = cloudinaryUrl(item.url, 'w_1600,q_auto,f_auto')
      document.getElementById('lightboxImg').alt = item.title || ''
      document.getElementById('lightboxCaption').textContent = item.title || ''
    }
    window.stepLightbox = function (dir) { showLightboxItem(__lightboxIndex + dir) }
    window.closeLightbox = function () { document.getElementById('lightbox').classList.remove('active') }
    document.getElementById('lightbox').addEventListener('click', function (e) { if (e.target === this) closeLightbox() })
    document.addEventListener('keydown', e => {
      const lb = document.getElementById('lightbox')
      if (!lb.classList.contains('active')) return
      if (e.key === 'Escape') closeLightbox()
      if (e.key === 'ArrowRight') stepLightbox(1)
      if (e.key === 'ArrowLeft') stepLightbox(-1)
    })

    document.addEventListener('contextmenu', e => { if (e.target.tagName === 'IMG') e.preventDefault() })
    document.addEventListener('dragstart', e => { if (e.target.tagName === 'IMG') e.preventDefault() })

    const navToggle   = document.querySelector('.nav-toggle')
    const mobileNav   = document.getElementById('mobileNav')
    const mobileClose = document.querySelector('.mobile-nav-close')
    navToggle.addEventListener('click', () => mobileNav.classList.add('open'))
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'))
    document.querySelectorAll('.mobile-nav-link').forEach(l => l.addEventListener('click', () => mobileNav.classList.remove('open')))
  